import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'a-overlay',
  template: `<div><ng-content></ng-content></div>`,
  styleUrls: ['./a-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AOverlayComponent {}
